module.exports = __webpack_public_path__ + "img/marjukka-pro.49477e20.jpg";